import React from 'react';
import RecognitionData from '@components/Recognition-Data/RecognitionData';

function RecognitionPage() {

    return (
        <div className={'RecognitionData'}>
            <RecognitionData />
           
        </div>
    )
}

export default RecognitionPage;
